module.exports = __webpack_public_path__ + "static/media/send.a3666864.svg";